import { Component, inject } from '@angular/core';
import { SaleClauseService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SaleClauseCreateDto,
  SaleClauseDto,
  SaleClauseExcelDownloadDto,
  SaleClauseUpdateDto,
} from '../proxy/controlling/dtos/sale-clause';
import { SALECLAUSE_CONFIG, SALECLAUSE_FIELDS } from './sale-clause.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sale-clause',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SaleClauseService, ConfirmationService],
  templateUrl: './sale-clause.html',
  styleUrl: './sale-clause.scss',
})
export class SaleClause extends BaseCrudComponent<
  SaleClauseDto,
  SaleClauseCreateDto,
  SaleClauseUpdateDto,
  SaleClauseExcelDownloadDto
> {
  service = inject(SaleClauseService);
  config = SALECLAUSE_CONFIG;
  fields = SALECLAUSE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SaleClauseDto): SaleClauseUpdateDto {
    return {
      name: data.name,
      value: data.value,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SaleClause';
  }
}
